import { render } from "./FollowUpRatingSummary.vue?vue&type=template&id=4f9ffdaa&scoped=true"
import script from "./FollowUpRatingSummary.vue?vue&type=script&lang=js"
export * from "./FollowUpRatingSummary.vue?vue&type=script&lang=js"

import "./FollowUpRatingSummary.vue?vue&type=style&index=0&id=4f9ffdaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9ffdaa"]])

export default __exports__